import { render, staticRenderFns } from "./ElementLogo.vue?vue&type=template&id=42480c57"
import script from "./ElementLogo.vue?vue&type=script&lang=js"
export * from "./ElementLogo.vue?vue&type=script&lang=js"
import style0 from "./ElementLogo.vue?vue&type=style&index=0&id=42480c57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports